import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    "& table.MuiTable-root": {
      tableLayout: "fixed",
      "& th.MuiTableCell-root:first-child": {
        width: "50px",
      },
    },
    maxHeight: 440,
  },
  tableHead: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  cell: {
    padding: 4,
  },
}));

export default useStyles;
